var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.18403V11.625C12 14.3174 9.81743 16.5 7.125 16.5C4.43261 16.5 2.25 14.3174 2.25 11.625C2.25 8.93257 4.43261 6.75 7.125 6.75C7.51223 6.75 7.88888 6.79514 8.25 6.88045V9.2526C7.90905 9.0906 7.5276 9 7.125 9C5.67525 9 4.5 10.1753 4.5 11.625C4.5 13.0747 5.67525 14.25 7.125 14.25C8.57475 14.25 9.75 13.0747 9.75 11.625V1.5H12C12 3.57107 13.679 5.25 15.75 5.25V7.5C14.3311 7.5 13.0272 7.00746 12 6.18403Z",
    fill: "#25262D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokFill);
export default __webpack_public_path__ + "static/media/tiktok-fill.16c6e62082b90d935a0e129227dcd89e.svg";
export { ForwardRef as ReactComponent };